// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"wrapper_scroll-black__U6_nz","wrapper":"wrapper_wrapper__XOG7u"};